import type { RouteObject } from 'react-router-dom';
import { InventoryPage } from '../features/inventory/InventoryPage';
import { LotDetailPage } from '../features/lots/LotDetailPage';
import { LotsPage } from '../features/lots/LotsPage';
import { CreateQrWizard } from '../features/qrs/CreateQrWizard';
import { QrDetailPage } from '../features/qrs/QrDetailPage';
import { QrsPage } from '../features/qrs/QrsPage';

/** Hijos de `/consola` para inventario, lotes y QR (F4.T7, F4.T8, F7.T4, F10.T6). */
export const consolaQrRoutes: RouteObject[] = [
  { path: 'inventario', element: <InventoryPage /> },
  { path: 'lotes', element: <LotsPage /> },
  { path: 'lotes/:lotId', element: <LotDetailPage /> },
  { path: 'qr', element: <QrsPage /> },
  { path: 'qr/nuevo', element: <CreateQrWizard /> },
  { path: 'qr/:code', element: <QrDetailPage /> },
];
